import React, { FC } from "react";

import { monitoringTable } from "../../constants/table";
import Table from "../Table";

const Monitoring: FC = () => <Table table={monitoringTable}/>;

export default Monitoring;
